// extracted by mini-css-extract-plugin
export default {"navigation_container":"NavigationTitle_navigation_container__UBQBB","back_icon":"NavigationTitle_back_icon__Te5PT","text_container":"NavigationTitle_text_container__aH2Wd"};